/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemDTO,
  LineItemDTOOptional,
  LineItemDTOMetaI,
  LineItemDTOTrackedI,
} from "./line-item-dto";
import { LineItemDTOTracked, LineItemDTOMeta } from "./line-item-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderCalculated,
  OrderCalculatedOptional,
  OrderCalculatedMetaI,
  OrderCalculatedTrackedI,
} from "./order-calculated";
import {
  OrderCalculatedTracked,
  OrderCalculatedMeta,
} from "./order-calculated";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderFull,
  OrderFullOptional,
  OrderFullMetaI,
  OrderFullTrackedI,
} from "./order-full";
import { OrderFullTracked, OrderFullMeta } from "./order-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentDTO,
  OrderPaymentDTOOptional,
  OrderPaymentDTOMetaI,
  OrderPaymentDTOTrackedI,
} from "./order-payment-dto";
import {
  OrderPaymentDTOTracked,
  OrderPaymentDTOMeta,
} from "./order-payment-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderSource,
  OrderSourceOptional,
  OrderSourceMetaI,
  OrderSourceTrackedI,
} from "./order-source";
import { OrderSourceTracked, OrderSourceMeta } from "./order-source";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderStateNew,
  OrderStateNewOptional,
  OrderStateNewMetaI,
  OrderStateNewTrackedI,
} from "./order-state-new";
import { OrderStateNewTracked, OrderStateNewMeta } from "./order-state-new";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UserRef,
  UserRefOptional,
  UserRefMetaI,
  UserRefTrackedI,
} from "./user-ref";
import { UserRefTracked, UserRefMeta } from "./user-ref";

/**
 *
 * @export
 * @interface OrderDTO
 */
export interface OrderDTOOptional extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  createdBy?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrderDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderDTO
   */
  assignId?: number;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderDTO
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderDTO
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderDTO
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderDTO
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderDTO
   */
  version?: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderDTO
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  squareOrderId?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof OrderDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {Array<LineItemDTO>}
   * @memberof OrderDTO
   */
  lineItems?: LineItemDTOOptional[];
  /**
   *
   * @type {Array<OrderPaymentDTO>}
   * @memberof OrderDTO
   */
  orderPayments?: OrderPaymentDTOOptional[];
  /**
   *
   * @type {UserRef}
   * @memberof OrderDTO
   */
  user?: UserRefOptional;
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderDTO
   */
  amountServiceChangeCents?: number;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountCapturableCents?: number;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountAppliedCents?: number;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountPendingCents?: number;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountRefundedCents?: number;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderDTO
   */
  amountToRefundCents?: number;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderDTO
   */
  amountToPayCents?: number;
}

export interface OrderDTO
  extends OrderDTOOptional, DBHistory, OrderCalculated, OrderFull {
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  createdBy?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrderDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderDTO
   */
  assignId: number;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderDTO
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderDTO
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderDTO
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderDTO
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderDTO
   */
  version: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderDTO
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  squareOrderId?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof OrderDTO
   */
  personId?: PersonRef;
  /**
   *
   * @type {Array<LineItemDTO>}
   * @memberof OrderDTO
   */
  lineItems: LineItemDTO[];
  /**
   *
   * @type {Array<OrderPaymentDTO>}
   * @memberof OrderDTO
   */
  orderPayments?: OrderPaymentDTO[];
  /**
   *
   * @type {UserRef}
   * @memberof OrderDTO
   */
  user?: UserRef;
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderDTO
   */
  amountServiceChangeCents?: number;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountCapturableCents?: number;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountAppliedCents?: number;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountPendingCents?: number;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountRefundedCents?: number;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderDTO
   */
  amountToRefundCents?: number;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderDTO
   */
  amountToPayCents?: number;
}

export interface OrderDTOTrackedI extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderDTO
   */
  orderSource?: OrderSource;
  orderSourceIsSet: boolean;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderDTO
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderDTO
   */
  amountDiscountsCents?: number;
  amountDiscountsCentsIsSet: boolean;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderDTO
   */
  amountTaxesCents?: number;
  amountTaxesCentsIsSet: boolean;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderDTO
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderDTO
   */
  version?: number;
  versionIsSet: boolean;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderDTO
   */
  orderStatus?: OrderStateNew;
  orderStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderDTO
   */
  squareOrderId?: string;
  squareOrderIdIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof OrderDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {Array<LineItemDTO>}
   * @memberof OrderDTO
   */
  lineItems?: LineItemDTOTrackedI[];
  lineItemsIsSet: boolean;
  /**
   *
   * @type {Array<OrderPaymentDTO>}
   * @memberof OrderDTO
   */
  orderPayments?: OrderPaymentDTOTrackedI[];
  orderPaymentsIsSet: boolean;
  /**
   *
   * @type {UserRef}
   * @memberof OrderDTO
   */
  user?: UserRefTrackedI;
  userIsSet: boolean;
  /**
   * Total cost of service charges (Payment fees paid by customer, maybe we will add restock service fee?)
   * @type {number}
   * @memberof OrderDTO
   */
  amountServiceChangeCents?: number;
  amountServiceChangeCentsIsSet: boolean;
  /**
   * Total of all capturable payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountCapturableCents?: number;
  amountCapturableCentsIsSet: boolean;
  /**
   * Total of all capturable and paid payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountAppliedCents?: number;
  amountAppliedCentsIsSet: boolean;
  /**
   * Total of all pending payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountPendingCents?: number;
  amountPendingCentsIsSet: boolean;
  /**
   * Total of all refunded payments
   * @type {number}
   * @memberof OrderDTO
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   * Total of all refunded items
   * @type {number}
   * @memberof OrderDTO
   */
  amountToRefundCents?: number;
  amountToRefundCentsIsSet: boolean;
  /**
   * Total of all non-refunded items
   * @type {number}
   * @memberof OrderDTO
   */
  amountToPayCents?: number;
  amountToPayCentsIsSet: boolean;
}

transformDatesMap.set("OrderDTO", function (model: OrderDTO) {
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  const transformDatespersonId = transformDatesMap.get("PersonRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
  const transformDateslineItems = transformDatesMap.get("LineItemDTO");
  if (transformDateslineItems) {
    model.lineItems?.forEach((sub) => {
      transformDateslineItems(sub);
    });
  }
  const transformDatesorderPayments = transformDatesMap.get("OrderPaymentDTO");
  if (transformDatesorderPayments) {
    model.orderPayments?.forEach((sub) => {
      transformDatesorderPayments(sub);
    });
  }
  const transformDatesuser = transformDatesMap.get("UserRef");
  if (transformDatesuser && model.user) {
    transformDatesuser(model.user);
  }
});

export type OrderDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderSource: PropertyMeta<OrderSourceMetaI>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountDiscountsCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  version: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderStatus: PropertyMeta<OrderStateNewMetaI>;
  //isDate: false
  //isDatetime: false
  squareOrderId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  lineItems: PropertyMeta<LineItemDTOMetaI>;
  //isDate: false
  //isDatetime: false
  orderPayments: PropertyMeta<OrderPaymentDTOMetaI>;
  //isDate: false
  //isDatetime: false
  user: PropertyMeta<UserRefMetaI>;
  //isDate: false
  //isDatetime: false
  amountServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountAppliedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPendingCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToPayCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OrderDTOMeta: OrderDTOMetaI = {} as OrderDTOMetaI;
OrderDTOMeta = typeMeta("OrderDTO", {
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  orderSource: propertyMeta(
    "orderSource",
    false,
    false,
    false,
    OrderSourceMeta,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountDiscountsCents: propertyMeta(
    "amountDiscountsCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesCents: propertyMeta(
    "amountTaxesCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  version: propertyMeta("version", false, true, false, MetaTypesBase.number),
  orderStatus: propertyMeta(
    "orderStatus",
    false,
    false,
    false,
    OrderStateNewMeta,
  ),
  squareOrderId: propertyMeta(
    "squareOrderId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  personId: propertyMeta("personId", false, false, false, PersonRefMeta),
  lineItems: propertyMeta("lineItems", true, true, false, LineItemDTOMeta),
  orderPayments: propertyMeta(
    "orderPayments",
    true,
    false,
    false,
    OrderPaymentDTOMeta,
  ),
  user: propertyMeta("user", false, false, false, UserRefMeta),
  amountServiceChangeCents: propertyMeta(
    "amountServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountCapturableCents: propertyMeta(
    "amountCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountAppliedCents: propertyMeta(
    "amountAppliedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPendingCents: propertyMeta(
    "amountPendingCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToRefundCents: propertyMeta(
    "amountToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountToPayCents: propertyMeta(
    "amountToPayCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = OrderDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
  metaI.interfaces = metaI.interfaces.concat([OrderFullMeta]);
  metaI.isDeleted.inheritedFrom = OrderFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = OrderFullMeta.isNew;
  metaI.assignId.inheritedFrom = OrderFullMeta.assignId;
  metaI.orderSource.inheritedFrom = OrderFullMeta.orderSource;
  metaI.amountSubtotalCents.inheritedFrom = OrderFullMeta.amountSubtotalCents;
  metaI.amountDiscountsCents.inheritedFrom = OrderFullMeta.amountDiscountsCents;
  metaI.amountTaxesCents.inheritedFrom = OrderFullMeta.amountTaxesCents;
  metaI.amountTotalCents.inheritedFrom = OrderFullMeta.amountTotalCents;
  metaI.amountPaidCents.inheritedFrom = OrderFullMeta.amountPaidCents;
  metaI.version.inheritedFrom = OrderFullMeta.version;
  metaI.orderStatus.inheritedFrom = OrderFullMeta.orderStatus;
  metaI.squareOrderId.inheritedFrom = OrderFullMeta.squareOrderId;
  metaI.personId.inheritedFrom = OrderFullMeta.personId;
  metaI.lineItems.inheritedFrom = OrderFullMeta.lineItems;
  metaI.orderPayments.inheritedFrom = OrderFullMeta.orderPayments;
  metaI.user.inheritedFrom = OrderFullMeta.user;
  metaI.interfaces = metaI.interfaces.concat([OrderCalculatedMeta]);
  metaI.amountServiceChangeCents.inheritedFrom =
    OrderCalculatedMeta.amountServiceChangeCents;
  metaI.amountCapturableCents.inheritedFrom =
    OrderCalculatedMeta.amountCapturableCents;
  metaI.amountAppliedCents.inheritedFrom =
    OrderCalculatedMeta.amountAppliedCents;
  metaI.amountPendingCents.inheritedFrom =
    OrderCalculatedMeta.amountPendingCents;
  metaI.amountRefundedCents.inheritedFrom =
    OrderCalculatedMeta.amountRefundedCents;
  metaI.amountToRefundCents.inheritedFrom =
    OrderCalculatedMeta.amountToRefundCents;
  metaI.amountToPayCents.inheritedFrom = OrderCalculatedMeta.amountToPayCents;
});

export class OrderDTOTracked
  extends DBHistoryTracked
  implements OrderDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  orderSource__I?: OrderSource = undefined;
  orderSourceIsSet: boolean = false;
  set orderSource(v: undefined | OrderSource) {
    if (v !== undefined) {
      this.orderSource__I = v;
      this.orderSourceIsSet = true;
    } else {
      this.orderSource__I = v || undefined;
      this.orderSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderSource() {
    return this.orderSource__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountDiscountsCents__I?: number = undefined;
  amountDiscountsCentsIsSet: boolean = false;
  set amountDiscountsCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsCents__I = v;
      this.amountDiscountsCentsIsSet = true;
    } else {
      this.amountDiscountsCents__I = v || undefined;
      this.amountDiscountsCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsCents() {
    return this.amountDiscountsCents__I;
  }
  amountTaxesCents__I?: number = undefined;
  amountTaxesCentsIsSet: boolean = false;
  set amountTaxesCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesCents__I = v;
      this.amountTaxesCentsIsSet = true;
    } else {
      this.amountTaxesCents__I = v || undefined;
      this.amountTaxesCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesCents() {
    return this.amountTaxesCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  version__I?: number = undefined;
  versionIsSet: boolean = false;
  set version(v: undefined | number) {
    if (v !== undefined) {
      this.version__I = v;
      this.versionIsSet = true;
    } else {
      this.version__I = v || undefined;
      this.versionIsSet = true;
    }
    this.changeTracker = true;
  }
  get version() {
    return this.version__I;
  }
  orderStatus__I?: OrderStateNew = undefined;
  orderStatusIsSet: boolean = false;
  set orderStatus(v: undefined | OrderStateNew) {
    if (v !== undefined) {
      this.orderStatus__I = v;
      this.orderStatusIsSet = true;
    } else {
      this.orderStatus__I = v || undefined;
      this.orderStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderStatus() {
    return this.orderStatus__I;
  }
  squareOrderId__I?: string = undefined;
  squareOrderIdIsSet: boolean = false;
  set squareOrderId(v: undefined | string) {
    if (v !== undefined) {
      this.squareOrderId__I = v;
      this.squareOrderIdIsSet = true;
    } else {
      this.squareOrderId__I = v || undefined;
      this.squareOrderIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareOrderId() {
    return this.squareOrderId__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  lineItems__I?: LineItemDTOTracked[] = undefined;
  lineItemsIsSet: boolean = false;
  set lineItems(v: undefined | LineItemDTOTracked[]) {
    if (v !== undefined) {
      this.lineItems__I = v;
      this.lineItemsIsSet = true;
    } else {
      this.lineItems__I = v || undefined;
      this.lineItemsIsSet = true;
    }
    this.changeTracker = true;
  }
  get lineItems() {
    return this.lineItems__I;
  }
  orderPayments__I?: OrderPaymentDTOTracked[] = undefined;
  orderPaymentsIsSet: boolean = false;
  set orderPayments(v: undefined | OrderPaymentDTOTracked[]) {
    if (v !== undefined) {
      this.orderPayments__I = v;
      this.orderPaymentsIsSet = true;
    } else {
      this.orderPayments__I = v || undefined;
      this.orderPaymentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderPayments() {
    return this.orderPayments__I;
  }
  user__I?: UserRefTracked = undefined;
  userIsSet: boolean = false;
  set user(v: undefined | UserRefTracked) {
    if (v !== undefined) {
      this.user__I = v;
      this.userIsSet = true;
    } else {
      this.user__I = v || undefined;
      this.userIsSet = false;
    }
    this.changeTracker = true;
  }
  get user() {
    return this.user__I;
  }
  amountServiceChangeCents__I?: number = undefined;
  amountServiceChangeCentsIsSet: boolean = false;
  set amountServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountServiceChangeCents__I = v;
      this.amountServiceChangeCentsIsSet = true;
    } else {
      this.amountServiceChangeCents__I = v || undefined;
      this.amountServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountServiceChangeCents() {
    return this.amountServiceChangeCents__I;
  }
  amountCapturableCents__I?: number = undefined;
  amountCapturableCentsIsSet: boolean = false;
  set amountCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCapturableCents__I = v;
      this.amountCapturableCentsIsSet = true;
    } else {
      this.amountCapturableCents__I = v || undefined;
      this.amountCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCapturableCents() {
    return this.amountCapturableCents__I;
  }
  amountAppliedCents__I?: number = undefined;
  amountAppliedCentsIsSet: boolean = false;
  set amountAppliedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountAppliedCents__I = v;
      this.amountAppliedCentsIsSet = true;
    } else {
      this.amountAppliedCents__I = v || undefined;
      this.amountAppliedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountAppliedCents() {
    return this.amountAppliedCents__I;
  }
  amountPendingCents__I?: number = undefined;
  amountPendingCentsIsSet: boolean = false;
  set amountPendingCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPendingCents__I = v;
      this.amountPendingCentsIsSet = true;
    } else {
      this.amountPendingCents__I = v || undefined;
      this.amountPendingCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPendingCents() {
    return this.amountPendingCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  amountToRefundCents__I?: number = undefined;
  amountToRefundCentsIsSet: boolean = false;
  set amountToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundCents__I = v;
      this.amountToRefundCentsIsSet = true;
    } else {
      this.amountToRefundCents__I = v || undefined;
      this.amountToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundCents() {
    return this.amountToRefundCents__I;
  }
  amountToPayCents__I?: number = undefined;
  amountToPayCentsIsSet: boolean = false;
  set amountToPayCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToPayCents__I = v;
      this.amountToPayCentsIsSet = true;
    } else {
      this.amountToPayCents__I = v || undefined;
      this.amountToPayCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToPayCents() {
    return this.amountToPayCents__I;
  }
  constructor(config?: OrderDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.lineItems?.forEach((a) => a.setIds());

    this.orderPayments?.forEach((a) => a.setIds());
    this.user?.setIds();
  }
  assignFrom(
    config: OrderDTOOptional,
    options?: AssignOptions,
  ): OrderDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.orderSource &&
      this.orderSourceApplyFilter(optionsRequired.filter)
    ) {
      this.orderSource = config.orderSource;
      if (optionsRequired.unassign) this.orderSourceIsSet = false;
      else this.orderSourceIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountDiscountsCents &&
      this.amountDiscountsCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsCents = config.amountDiscountsCents;
      if (optionsRequired.unassign) this.amountDiscountsCentsIsSet = false;
      else this.amountDiscountsCentsIsSet = true;
    }
    if (
      config.amountTaxesCents &&
      this.amountTaxesCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesCents = config.amountTaxesCents;
      if (optionsRequired.unassign) this.amountTaxesCentsIsSet = false;
      else this.amountTaxesCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (config.version && this.versionApplyFilter(optionsRequired.filter)) {
      this.version = config.version;
      if (optionsRequired.unassign) this.versionIsSet = false;
      else this.versionIsSet = true;
    }
    if (
      config.orderStatus &&
      this.orderStatusApplyFilter(optionsRequired.filter)
    ) {
      this.orderStatus = config.orderStatus;
      if (optionsRequired.unassign) this.orderStatusIsSet = false;
      else this.orderStatusIsSet = true;
    }
    if (
      config.squareOrderId &&
      this.squareOrderIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareOrderId = config.squareOrderId;
      if (optionsRequired.unassign) this.squareOrderIdIsSet = false;
      else this.squareOrderIdIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (config.lineItems && this.lineItemsApplyFilter(optionsRequired.filter)) {
      this.lineItems = config.lineItems?.map(
        (a) => new LineItemDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.lineItemsIsSet = false;
      else this.lineItemsIsSet = true;
    }
    if (
      config.orderPayments &&
      this.orderPaymentsApplyFilter(optionsRequired.filter)
    ) {
      this.orderPayments = config.orderPayments?.map(
        (a) => new OrderPaymentDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.orderPaymentsIsSet = false;
      else this.orderPaymentsIsSet = true;
    }
    if (config.user && this.userApplyFilter(optionsRequired.filter)) {
      this.user = new UserRefTracked(config.user, options);
      if (optionsRequired.unassign) this.userIsSet = false;
      else this.userIsSet = true;
    }
    if (
      config.amountServiceChangeCents &&
      this.amountServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountServiceChangeCents = config.amountServiceChangeCents;
      if (optionsRequired.unassign) this.amountServiceChangeCentsIsSet = false;
      else this.amountServiceChangeCentsIsSet = true;
    }
    if (
      config.amountCapturableCents &&
      this.amountCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCapturableCents = config.amountCapturableCents;
      if (optionsRequired.unassign) this.amountCapturableCentsIsSet = false;
      else this.amountCapturableCentsIsSet = true;
    }
    if (
      config.amountAppliedCents &&
      this.amountAppliedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountAppliedCents = config.amountAppliedCents;
      if (optionsRequired.unassign) this.amountAppliedCentsIsSet = false;
      else this.amountAppliedCentsIsSet = true;
    }
    if (
      config.amountPendingCents &&
      this.amountPendingCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPendingCents = config.amountPendingCents;
      if (optionsRequired.unassign) this.amountPendingCentsIsSet = false;
      else this.amountPendingCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.amountToRefundCents &&
      this.amountToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundCents = config.amountToRefundCents;
      if (optionsRequired.unassign) this.amountToRefundCentsIsSet = false;
      else this.amountToRefundCentsIsSet = true;
    }
    if (
      config.amountToPayCents &&
      this.amountToPayCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToPayCents = config.amountToPayCents;
      if (optionsRequired.unassign) this.amountToPayCentsIsSet = false;
      else this.amountToPayCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderDTOTrackedI {
    const cloned = {} as OrderDTOTrackedI;
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.orderSourceIsSetDeep() &&
      this.orderSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderSourceIsSet = true;
      cloned.orderSource = this.orderSource;
    } else {
      //cloned.orderSourceIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountDiscountsCentsIsSetDeep() &&
      this.amountDiscountsCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsCentsIsSet = true;
      cloned.amountDiscountsCents = this.amountDiscountsCents;
    } else {
      //cloned.amountDiscountsCentsIsSet = false
    }
    if (
      this.amountTaxesCentsIsSetDeep() &&
      this.amountTaxesCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesCentsIsSet = true;
      cloned.amountTaxesCents = this.amountTaxesCents;
    } else {
      //cloned.amountTaxesCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.versionIsSetDeep() &&
      this.versionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.versionIsSet = true;
      cloned.version = this.version;
    } else {
      //cloned.versionIsSet = false
    }
    if (
      this.orderStatusIsSetDeep() &&
      this.orderStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderStatusIsSet = true;
      cloned.orderStatus = this.orderStatus;
    } else {
      //cloned.orderStatusIsSet = false
    }
    if (
      this.squareOrderIdIsSetDeep() &&
      this.squareOrderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareOrderIdIsSet = true;
      cloned.squareOrderId = this.squareOrderId;
    } else {
      //cloned.squareOrderIdIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.lineItemsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.lineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lineItemsIsSet = true;
      cloned.lineItems = this.lineItems
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.lineItemsIsSet = false
    }
    if (
      this.orderPaymentsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.orderPaymentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderPaymentsIsSet = true;
      cloned.orderPayments = this.orderPayments
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.orderPaymentsIsSet = false
    }
    if (
      this.userIsSetDeep() &&
      this.userApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.userIsSet = true;
      cloned.user = this.user?.removeUnset(filter);
    } else {
      //cloned.userIsSet = false
    }
    if (
      this.amountServiceChangeCentsIsSetDeep() &&
      this.amountServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountServiceChangeCentsIsSet = true;
      cloned.amountServiceChangeCents = this.amountServiceChangeCents;
    } else {
      //cloned.amountServiceChangeCentsIsSet = false
    }
    if (
      this.amountCapturableCentsIsSetDeep() &&
      this.amountCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCapturableCentsIsSet = true;
      cloned.amountCapturableCents = this.amountCapturableCents;
    } else {
      //cloned.amountCapturableCentsIsSet = false
    }
    if (
      this.amountAppliedCentsIsSetDeep() &&
      this.amountAppliedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountAppliedCentsIsSet = true;
      cloned.amountAppliedCents = this.amountAppliedCents;
    } else {
      //cloned.amountAppliedCentsIsSet = false
    }
    if (
      this.amountPendingCentsIsSetDeep() &&
      this.amountPendingCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPendingCentsIsSet = true;
      cloned.amountPendingCents = this.amountPendingCents;
    } else {
      //cloned.amountPendingCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.amountToRefundCentsIsSetDeep() &&
      this.amountToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundCentsIsSet = true;
      cloned.amountToRefundCents = this.amountToRefundCents;
    } else {
      //cloned.amountToRefundCentsIsSet = false
    }
    if (
      this.amountToPayCentsIsSetDeep() &&
      this.amountToPayCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToPayCentsIsSet = true;
      cloned.amountToPayCents = this.amountToPayCents;
    } else {
      //cloned.amountToPayCentsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderDTOTrackedI {
    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.orderSourceApplyFilter(filter)) this.orderSourceIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountDiscountsCentsApplyFilter(filter))
      this.amountDiscountsCentsIsSet = false;

    if (!this.amountTaxesCentsApplyFilter(filter))
      this.amountTaxesCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.versionApplyFilter(filter)) this.versionIsSet = false;

    if (!this.orderStatusApplyFilter(filter)) this.orderStatusIsSet = false;

    if (!this.squareOrderIdApplyFilter(filter)) this.squareOrderIdIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.lineItemsApplyFilter(filter)) this.lineItemsIsSet = false;

    this.lineItems?.forEach((a) => a.unassignAll(filter));
    if (!this.orderPaymentsApplyFilter(filter)) this.orderPaymentsIsSet = false;

    this.orderPayments?.forEach((a) => a.unassignAll(filter));
    if (!this.userApplyFilter(filter)) this.userIsSet = false;
    this.user?.unassignAll(filter);

    if (!this.amountServiceChangeCentsApplyFilter(filter))
      this.amountServiceChangeCentsIsSet = false;

    if (!this.amountCapturableCentsApplyFilter(filter))
      this.amountCapturableCentsIsSet = false;

    if (!this.amountAppliedCentsApplyFilter(filter))
      this.amountAppliedCentsIsSet = false;

    if (!this.amountPendingCentsApplyFilter(filter))
      this.amountPendingCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.amountToRefundCentsApplyFilter(filter))
      this.amountToRefundCentsIsSet = false;

    if (!this.amountToPayCentsApplyFilter(filter))
      this.amountToPayCentsIsSet = false;

    return this;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.updatedOn, OrderDTOMeta, this.updatedOn, this);
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.updatedBy, OrderDTOMeta, this.updatedBy, this);
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.createdOn, OrderDTOMeta, this.createdOn, this);
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.createdBy, OrderDTOMeta, this.createdBy, this);
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.isDeleted, OrderDTOMeta, this.isDeleted, this);
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.isNew, OrderDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.assignId, OrderDTOMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  orderSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.orderSource,
      OrderDTOMeta,
      this.orderSource,
      this,
    );
  }
  orderSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderSourceIsSet && this.orderSourceApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountSubtotalCents,
      OrderDTOMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountDiscountsCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountDiscountsCents,
      OrderDTOMeta,
      this.amountDiscountsCents,
      this,
    );
  }
  amountDiscountsCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsCentsIsSet &&
      this.amountDiscountsCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountTaxesCents,
      OrderDTOMeta,
      this.amountTaxesCents,
      this,
    );
  }
  amountTaxesCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTaxesCentsIsSet && this.amountTaxesCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountTotalCents,
      OrderDTOMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountPaidCents,
      OrderDTOMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  versionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.version, OrderDTOMeta, this.version, this);
  }
  versionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.versionIsSet && this.versionApplyFilter(filter)) return true;

    return false;
  }
  orderStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.orderStatus,
      OrderDTOMeta,
      this.orderStatus,
      this,
    );
  }
  orderStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderStatusIsSet && this.orderStatusApplyFilter(filter))
      return true;

    return false;
  }
  squareOrderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.squareOrderId,
      OrderDTOMeta,
      this.squareOrderId,
      this,
    );
  }
  squareOrderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareOrderIdIsSet && this.squareOrderIdApplyFilter(filter))
      return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.personId, OrderDTOMeta, this.personId, this);
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  lineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.lineItems, OrderDTOMeta, this.lineItems, this);
  }
  lineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lineItemsIsSet && this.lineItemsApplyFilter(filter)) return true;

    return this.lineItems?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  orderPaymentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.orderPayments,
      OrderDTOMeta,
      this.orderPayments,
      this,
    );
  }
  orderPaymentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderPaymentsIsSet && this.orderPaymentsApplyFilter(filter))
      return true;

    return this.orderPayments?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  userApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderDTOMeta.user, OrderDTOMeta, this.user, this);
  }
  userIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.userIsSet && this.userApplyFilter(filter)) return true;
    return this.user?.anySet(filter) == true;

    return false;
  }
  amountServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountServiceChangeCents,
      OrderDTOMeta,
      this.amountServiceChangeCents,
      this,
    );
  }
  amountServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountServiceChangeCentsIsSet &&
      this.amountServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountCapturableCents,
      OrderDTOMeta,
      this.amountCapturableCents,
      this,
    );
  }
  amountCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountCapturableCentsIsSet &&
      this.amountCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountAppliedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountAppliedCents,
      OrderDTOMeta,
      this.amountAppliedCents,
      this,
    );
  }
  amountAppliedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountAppliedCentsIsSet &&
      this.amountAppliedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountPendingCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountPendingCents,
      OrderDTOMeta,
      this.amountPendingCents,
      this,
    );
  }
  amountPendingCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountPendingCentsIsSet &&
      this.amountPendingCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountRefundedCents,
      OrderDTOMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountToRefundCents,
      OrderDTOMeta,
      this.amountToRefundCents,
      this,
    );
  }
  amountToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundCentsIsSet &&
      this.amountToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountToPayCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderDTOMeta.amountToPayCents,
      OrderDTOMeta,
      this.amountToPayCents,
      this,
    );
  }
  amountToPayCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountToPayCentsIsSet && this.amountToPayCentsApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.orderSourceIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountDiscountsCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.versionIsSetDeep(filter)) return true;
    if (this.orderStatusIsSetDeep(filter)) return true;
    if (this.squareOrderIdIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.lineItemsIsSetDeep(filter)) return true;
    if (this.orderPaymentsIsSetDeep(filter)) return true;
    if (this.userIsSetDeep(filter)) return true;
    if (this.amountServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.amountCapturableCentsIsSetDeep(filter)) return true;
    if (this.amountAppliedCentsIsSetDeep(filter)) return true;
    if (this.amountPendingCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.amountToRefundCentsIsSetDeep(filter)) return true;
    if (this.amountToPayCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
